import { recentActivitiesQuery } from '@atlassian/search-client';

export const fetchRecentActivities = async (
	cloudId: string,
	aggAbsoluteUrl: string | undefined,
) => {
	return await recentActivitiesQuery({
		variables: {
			filteredProducts: ['confluence', 'jira', 'townsquare'],
			filteredObjectTypes: [
				'page',
				'blogpost',
				'whiteboard',
				'issue',
				'project',
				'goal',
				'content',
			],
			filteredRootContainerIds: [
				`ari:cloud:platform::site/${cloudId}`,
				`ari:cloud:townsquare::site/${cloudId}`,
			],
			itemsLimit: 200,
		},
		aggAbsoluteUrl,
	}).then((response) => {
		return response.data?.activity?.myActivity?.all?.edges || [];
	});
};
